// Vendors
import { CookieStorage } from '@openbank/web-ui-framework';
// Constants
import constants from './constants/cookies.constants';
const CookiesStorage = new CookieStorage(constants.COOKIES_STORAGE_PROPS);
export { CookiesStorage };
//# sourceMappingURL=index.js.map